import { render, staticRenderFns } from "./confidentialitySetting.vue?vue&type=template&id=209a4888&scoped=true"
import script from "./confidentialitySetting.vue?vue&type=script&lang=js"
export * from "./confidentialitySetting.vue?vue&type=script&lang=js"
import style0 from "./confidentialitySetting.vue?vue&type=style&index=0&id=209a4888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a4888",
  null
  
)

export default component.exports